import { useState } from "react";
import { Link } from "react-router-dom";
import { Mail, Loader2, CheckCircle2 } from "lucide-react";
import api from "@/lib/api";
import { Logo } from "@/components/Logo";
import Seo from "@/components/Seo";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch {
      setSent(true); // don't leak which emails exist
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex-1 grid place-items-center px-5 py-12">
      <Seo title="Reset password — MeasureTheRoof" description="Reset your MeasureTheRoof account password." path="/forgot-password" noindex />
      <div className="w-full max-w-md">
        <div className="flex justify-center mb-6"><Logo /></div>
        <div className="card-mtr">
          {sent ? (
            <div className="text-center" data-testid="forgot-sent">
              <CheckCircle2 className="text-go-green mx-auto mb-3" size={40} />
              <h1 className="font-body font-extrabold text-navy text-[22px] mb-2">Check your email</h1>
              <p className="text-mortar text-[14px]">
                If an account exists for <strong className="text-iron">{email}</strong>, we've sent a link to reset your password. The link expires in 1 hour.
              </p>
            </div>
          ) : (
            <>
              <h1 className="font-body font-extrabold text-navy text-[24px] mb-1">Forgot password</h1>
              <p className="text-mortar text-[14px] mb-6">Enter your email and we'll send a reset link.</p>
              <form onSubmit={submit} className="space-y-4">
                <div>
                  <label htmlFor="email" className="label-mtr">Email</label>
                  <div className="relative">
                    <Mail size={18} className="absolute left-4 top-1/2 -translate-y-1/2 text-mortar" aria-hidden="true" />
                    <input id="email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="input-mtr pl-11" placeholder="you@company.com" data-testid="forgot-email" />
                  </div>
                </div>
                <button type="submit" disabled={loading} className="btn-primary w-full" data-testid="forgot-submit">
                  {loading ? <Loader2 className="animate-spin" size={18} /> : "Send reset link"}
                </button>
              </form>
            </>
          )}
        </div>
        <p className="text-center text-[14px] text-mortar mt-5">
          <Link to="/login" className="text-orange font-bold">Back to log in</Link>
        </p>
      </div>
    </div>
  );
}
